import { fetchListing as apiFetchListing } from 'api/orgs';
import { ImportedListing } from 'api/volops';
import { getObject as algoliaGetObject } from 'utils/algoliaSearch';
import getSearchConfig from 'utils/search/getSearchConfig';
import getVolopsSearchIndex from 'utils/search/getVolopsSearchIndex';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Dispatch, GetState } from '..';
import { setError } from './error';

// Types

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Listing = Record<string, any>;
export type State = {
  byId: Record<
    string,
    Listing & {
      isFetching: boolean;
      isUnpublished: boolean;
    }
  >;
};

type FetchListingRequestAction = {
  type: 'FETCH_LISTING_REQUEST';
  listingId: string;
};
type FetchListingSuccessAction = {
  type: 'FETCH_LISTING_SUCCESS';
  listing: Listing;
};
type FetchImportedListingSuccessAction = {
  type: 'FETCH_IMPORTED_LISTING_SUCCESS';
  listing: ImportedListing;
};
type SetListingUnpublishedAction = {
  type: 'SET_LISTING_UNPUBLISHED';
  listingId: string;
  isUnpublished: boolean;
};
export type Action =
  | FetchListingRequestAction
  | FetchListingSuccessAction
  | FetchImportedListingSuccessAction
  | SetListingUnpublishedAction;

// Reducer

export default function listingsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
  },
  action: Action
) {
  switch (action.type) {
    case 'FETCH_LISTING_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.listingId]: {
            ...state.byId[action.listingId],
            id: action.listingId,
            isFetching: true,
          },
        },
      };

    case 'FETCH_LISTING_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.listing.id]: {
            ...action.listing,
            isFetching: false,
            isUnpublished: false,
          },
        },
      };

    case 'SET_LISTING_UNPUBLISHED':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.listingId]: {
            isFetching: false,
            isUnpublished: true,
          },
        },
      };

    case 'FETCH_IMPORTED_LISTING_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.listing.objectID]: {
            ...action.listing,
            id: action.listing.objectID,
            isFetching: false,
          },
        },
      };

    default:
      // this causes a flow error if there are any unhandled actions
      action as never;

      return state;
  }
}

// Actions

const fetchListingRequest = (listingId: string): FetchListingRequestAction => ({
  type: 'FETCH_LISTING_REQUEST',
  listingId,
});

export const setListingUnpublished = (
  listingId: string,
  isUnpublished: boolean
): SetListingUnpublishedAction => ({
  type: 'SET_LISTING_UNPUBLISHED',
  listingId,
  isUnpublished,
});

const fetchListingSuccess = (listing: Listing): FetchListingSuccessAction => ({
  type: 'FETCH_LISTING_SUCCESS',
  listing,
});

const fetchImportedListingSuccess = (
  listing: ImportedListing
): FetchImportedListingSuccessAction => ({
  type: 'FETCH_IMPORTED_LISTING_SUCCESS',
  listing,
});

export const fetchListing =
  (listingType: string, listingId: string, force = false) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const listing = state.listings.byId[listingId];

    if (!listing || (force && !listing.isFetching)) {
      dispatch(fetchListingRequest(listingId));
      return apiFetchListing(listingType, listingId).then((fetchedListing) => {
        dispatch(fetchListingSuccess(fetchedListing));
        return fetchedListing;
      });
    }

    return Promise.resolve(listing);
  };
export const fetchImportedListing =
  (listingId: string, force = false) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const listing = state.listings.byId[listingId];

    if (!listing || (force && !listing.isFetching)) {
      dispatch(fetchListingRequest(listingId));
      const searchConfig = getSearchConfig();
      const index = getVolopsSearchIndex(null, 'relevance');
      algoliaGetObject(searchConfig, index, listingId, ['*'])
        .then((fetchedListing) => {
          dispatch(fetchImportedListingSuccess(fetchedListing));
        })
        .catch((e) => {
          dispatch(setError(e));
        });
    }
  };
export const updateListing = fetchListingSuccess;
